import React from "react";
import "./resetPassword.scss";
import MimoLogo from "../../containers/layout/sidebar/mimoLogo";
import { Button, Form } from "react-bootstrap";
import Spinner from "../../components/ui/spinner";
import useResetPassword from "./useResetPassword";
import { Notification } from "../../components/notification";

const ResetPassword = () => {
  const {
    organizationName,
    adminName,
    email,
    password,
    confirmPassword,
    passwordError,
    confirmPasswordError,
    handlePasswordChange,
    handleConfirmPasswordChange,
    submitResetPassword,
    isLoading,
    setIsLoading,
    isValidPassword
  } = useResetPassword();

  return (
    <>
      <Notification />
      <Spinner isActive={isLoading} />
      <div className="reset-password-container">
        <MimoLogo />
        <div className="reset-password-content">
          <h1>Reset Password</h1>
          <hr />

          <Form onSubmit={submitResetPassword}>
            <div className="reset-password-input">
              <Form.Label>Organization Name</Form.Label>
              <Form.Control type="text" value={organizationName} disabled />
            </div>

            <div className="reset-password-input">
              <Form.Label>Admin Name</Form.Label>
              <Form.Control type="text" value={adminName} disabled />
            </div>

            <div className="reset-password-input">
              <Form.Label>Email Address</Form.Label>
              <Form.Control type="email" value={email} disabled />
            </div>

            <div className="reset-password-input">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={handlePasswordChange}
                required
              />
              {passwordError && <p style={{ color: "red" }}>{passwordError}</p>}
            </div>

            <div className="reset-password-input">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                required
              />
              {confirmPasswordError && (
                <p style={{ color: "red" }}>{confirmPasswordError}</p>
              )}
            </div>

            <div className="reset-password-btn">
              <Button disabled={!isValidPassword} type="submit">Reset Password</Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
